import { FC } from 'react';
import { ActionCreators as UndoActionCreators } from 'redux-undo';
import { connect } from 'react-redux';
import { useHotkeys } from 'react-hotkeys-hook';
import { Options } from 'react-hotkeys-hook/src/useHotkeys';
import _get from 'lodash/get';

import { TAppState } from '../reducers';
import { setApplicationFocus } from '../actions/browser';
import applicationFocus from '../constants/applicationFocus';

interface IProps {
    OSName: string;
    multipleConnections: boolean;
    onUndo: () => void;
    onRedo: () => void;
    onRightPanelFocus: () => void;
}

const Hotkeys: FC<IProps> = ({ OSName, multipleConnections, onUndo, onRedo, onRightPanelFocus }): null => {
    const [undoKey, redoKey, rightPanelKey] =
        OSName === 'Max OS' ? ['cmd+z', 'cmd+shift+z', 'ctrl+option+s'] : ['ctrl+z', 'ctrl+shift+z', 'ctrl+alt+s'];

    const UNDO_REDO_OPTIONS: Partial<Options> = {
        enabled: !multipleConnections,
    };

    useHotkeys(undoKey, onUndo, UNDO_REDO_OPTIONS);
    useHotkeys(redoKey, onRedo, UNDO_REDO_OPTIONS);
    useHotkeys(rightPanelKey, onRightPanelFocus);

    return null;
};

const mapStateToProps = (state: TAppState) => {
    const allClients = _get(state, 'session.collaboration.connectedClients', []);
    const currentUserSockerId = _get(state, 'session.collaboration.currentUserSocketId', '');
    const connectedClients = allClients.filter((user: { socketId: string }) => user.socketId !== currentUserSockerId);

    return {
        OSName: state.browser.OSName,
        multipleConnections: connectedClients.length > 0,
    };
};

const mapDispatchToProps = (dispatch: any) => ({
    onUndo: () => dispatch(UndoActionCreators.undo()),
    onRedo: () => dispatch(UndoActionCreators.redo()),
    onRightPanelFocus: () => dispatch(setApplicationFocus(applicationFocus.RIGHT_PANEL)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Hotkeys);
